var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('amp-youtube',_vm._b({attrs:{"data-block-on-consent":"","data-videoid":_vm.ampVideoId,"layout":"responsive","width":_vm.widgetWidth,"height":_vm.widgetHeight}},'amp-youtube',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }